import { twMerge } from 'tailwind-merge';

interface EditButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
}

const defaultStyles = 'flex items-center justify-center cursor-pointer text-xxs font-medium';
const roundedStyles = 'px-[10px] py-[4px] bg-gray-200 rounded-[999px] inline-block';

export const EditButton = ({ children, className, onClick, disabled }: EditButtonProps) => (
  <p
    className={twMerge(defaultStyles, roundedStyles, disabled ? 'opacity-30 cursor-not-allowed' : '', className)}
    onClick={disabled ? undefined : onClick}>
    {children}
  </p>
);
